<template>
  <div>
    <v-row class="row mt-0 mb-5">
      <v-col cols="12" class="d-flex pb-0">
        <v-col cols="4">
          <!-- create payout record -->
          <v-btn color="secondary" @click="openCreateModal()">
            <v-icon left>mdi-newspaper-plus</v-icon>Create
          </v-btn>
          <!-- Reload button -->
          <v-btn color="secondary" @click.stop="reload()">
            <i class="fa fa-repeat fa-xs"></i>&nbsp;Reload
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <div class="mt-2">
      <v-data-table
        :headers="headers"
        :search="filter"
        :items="infLists"
        :items-per-page="15"
        class="elevation-1">
          <template v-slot:[`item.action`]="{ item }">
            <td style="width: 150px;">
              <!-- View Button -->
              <v-btn @click="getDataToView(item)" color="info" class="ims-action">
                <v-icon small data-toggle="tooltip" data-placement="top" title="View Influencer List">remove_red_eye</v-icon>
              </v-btn>
              <!-- Delete button -->
              <v-btn
                class="ims-action"
                @click="deleteInf(item)"
                color="red"
              >
                <v-icon v-on="on" color="white" data-toggle="tooltip" data-placement="top" title="Delete" small>mdi-delete-forever</v-icon>
              </v-btn>
            </td>
          </template>
      </v-data-table>
    </div>
    <view-influencer-list-modal
      v-model="viewInfListDialog"
      :value="viewInfListDialog"
      :creator="viewCreator"
      @reload="reload()"
    />
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import ViewInfluencerListModal from './ViewInfluencerListModal';
import { mapState } from 'vuex'
export default {
  name: 'InfluencerDataTable',
  props: ['refresh'],
  components: {
    ViewInfluencerListModal,
    Loading
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Action',
          value: 'action'
        }
      ],
      filter: '',
      viewCreator: null,
      filteredItems: [],
      viewInfListDialog: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      infLists: state => state.pairing.infLists,
      saved: state => state.pairing.saved
    })
  },
  async mounted() {
    // mounted here
    this.getInfLists()
  },
  methods: {
    openCreateModal() {
      // open create modal
      this.viewCreator = null
      this.viewInfListDialog = true
    },
    reload() {
      // impl reload here
      this.getInfLists()
    },
    async getInfLists() {
      await this.$store.dispatch('pairing/getInfLists')
    },
    getDataToView(item) {
      this.viewInfListDialog = true
      this.viewCreator = item
    },
    deleteInf(item) {
      this.$swal({
        title: 'Confirm',
        text: 'Are you sure to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let payload = {
            id: item.id
          }
          await this.$store.dispatch('pairing/deleteInfListData', payload)
          if (this.saved) {
            this.isLoading = false
            this.$swal({
              title: 'Successfully Deleted!',
              type: 'success'
            });
            this.reload()
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// DataTable.vue?18e0326e